import z from "zod";
import { LayoutIdScheme, ProductPageIdScheme } from "./ids";
import { LayoutItemScheme } from "./layoutItem";
import { ProductImageLayout } from "./enums/ProductImageLayout";
import { LayoutProductPriceDisplay } from "./enums/LayoutProductPriceDisplay";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const LayoutDBScheme = z.object({
  id: LayoutIdScheme,
  name: z.string(),

  topButtons: z.array(LayoutItemScheme),
  bottomButtons: z.array(LayoutItemScheme),
  leftButtons: z.array(LayoutItemScheme),
  rightButtons: z.array(LayoutItemScheme),
  checkoutButtons: z.array(LayoutItemScheme).optional(),
  checkoutButtonRowsBeforeShowAll: z.number().optional(),
  checkoutColumns: z.number().optional(),
  productPageItemSize: z.number().min(0.5).max(3).optional(),
  productImageLayout: z.enum(ProductImageLayout).optional(),
  productPriceDisplay: z.enum(LayoutProductPriceDisplay).optional(),
  centerButtonTextScale: z.number().min(0.75).max(4).optional(),
  edgeButtonTextScale: z.number().min(0.75).max(4).optional(),

  defaultProductPageId: ProductPageIdScheme.nullable(),
  origin: z.enum(CatalogOrigin).optional(),

  tabletColumns: z.number().optional(),
  tabletRows: z.number().optional(),
  mobileColumns: z.number().optional(),
  mobileRows: z.number().optional(),
  topRows: z.number().optional(),
  bottomRows: z.number().optional(),
  leftColumns: z.number().optional(),
  rightColumns: z.number().optional(),

  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetLayout = LayoutDBScheme;

export const RestCreateLayout = LayoutDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const RestUpdateLayout = LayoutDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export type DBLayout = z.infer<typeof LayoutDBScheme>;
export type RestLayout = z.infer<typeof RestGetLayout>;
export type RestCreateLayoutType = z.infer<typeof RestCreateLayout>;
export type RestUpdateLayoutType = z.infer<typeof RestUpdateLayout>;
export type LayoutItem = z.infer<typeof LayoutItemScheme>;
